(() => {
    const pristineScript = document.querySelector('#aorc-theme-pristine-js');

    const initPristineValidators = () => {
        Pristine.addValidator('max-size', function(value, maxSize) {
            if (!Array.from(this.files).length) return true;

            const invalidFiles = Array.from(this.files).some(file => {
                return file.size > maxSize;
            });

            return !invalidFiles;
        }, (value, params) => {
            return `File size must be below ${params[1] / 1000000}MB`;
        }, 5, false);
    };

    if (typeof Pristine !== 'undefined') {
        initPristineValidators();
    } else if (pristineScript) {
        pristineScript.addEventListener('load', () => {
            initPristineValidators();
        });
    } else {
        window.addEventListener('load', () => {
            const pristineScript = document.querySelector('#point-to-point-pristine-js');

            if (!pristineScript) return;

            initPristineValidators();
        });
    }
})();
